const message = {
  "button.home.sendFiles": "Invia file",

  "button.options.record": "Registra ora",
  "button.options.upload": "Scegli file",
  "button.options.gallery": "Guarda l’album",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Sfida fotografica",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Team Match",
  "button.options.foodMenu": "Menù",
  "button.options.schedule": "Programma",
  "button.options.feed": "Feed della festa",

  "message.options.bingoGame": "Gioca al bingo della festa!",
  "message.options.photoChallengeGame": "Partecipa alla sfida fotografica!",
  "message.options.quizGame": "Metti alla prova le tue conoscenze!",
  "message.options.teamMatchGame": "Da che squadra fai parte?",
  "message.options.foodMenu": "Guarda il menù della festa!",
  "message.options.schedule": "Scopri il programma dell’evento!",
  "message.options.record": "Registra ora il tuo messaggio speciale!",
  "message.options.upload": "Condividi le migliori foto e video della festa!",
  "message.options.gallery": "Guarda le foto dell’evento!",
  "message.options.feed": "Segui la timeline dell’evento!",

  "title.terms": "Termini di Utilizzo",
  "title.notFound": "Ops, sembra che questa pagina non esista.",
  "title.eventNotFound": "Errore durante l’accesso all’evento",

  "subtitle.goBackTo": "Torna alla",
  "subtitle.eventNotFound": "Evento non trovato o scaduto.",

  "message.termsOfUse":
    "Utilizzando il nostro sistema accetti i nostri <code>Termini di Utilizzo</code>",
  "message.termsFirstParagraph":
    "Utilizzando il nostro sistema di invio di foto e video, accetti che raccogliamo e inviamo i tuoi dati – inclusi foto, video e informazioni personali – al padrone di casa dell’evento.",
  "message.termsSecondParagraph":
    "Non accediamo ai tuoi file, se non su richiesta del cliente per fornire supporto tecnico, limitatamente al necessario.",
  "message.termsThirdParagraph":
    "L'azienda non condivide i dati con terze parti e mantiene la riservatezza delle informazioni, salvo obblighi legali.",
  "message.shareLink": "Condividi i tuoi momenti preferiti della festa!",

  //record
  "button.recorder.understood": "Capito!",
  "button.recorder.close": "Chiudi",
  "button.recorder.share": "Condividi",
  "button.recorder.home": "Torna alla home",
  "button.recorder.back": "Indietro",

  "title.recorder.permissionsToRecordAudioVideo": "Permesso per registrare",
  "title.recorder.success": "Successo!",
  "title.recorder.uploading": "Caricamento in corso",
  "title.recorder.alert": "Attenzione!",
  "title.recorder.saving": "Salvataggio",
  "title.recorder.waiting": "Attendere",
  "title.recorder.share": "Condividi!",
  "title.recorder.error": "Errore!",
  "title.recorder.permissionCameraOrMicrophoneDenied": "Permesso non concesso",
  "title.recorder.terms": "Termini di utilizzo",

  "subtitle.recorder.nextScreenClickAllow":
    "Nella prossima schermata, clicca su <code>Consenti</code>.",
  "subtitle.recorder.allowReinforcement":
    "Devi cliccare su <code>Consenti</code> per registrare il tuo messaggio.",
  "subtitle.recorder.share": "Invita i tuoi amici a registrare anche loro!",
  "subtitle.recorder.dontRefreshPage":
    "Per favore, non aggiornare né chiudere questa pagina.",
  "subtitle.recorder.status.success":
    "Il tuo messaggio è stato registrato con successo!",
  "subtitle.recorder.browserNotSupported":
    "Il tuo browser non è supportato o il permesso non è stato concesso.",
  "subtitle.recorder.tryGrantPermission":
    "1. Ricarica la pagina e consenti l’uso della fotocamera.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Prova a usare un altro browser come {chrome} o {safari}.",
  "subtitle.recorder.mustLongerThan":
    "Il messaggio deve durare più di <code>5 secondi</code>.",
  "subtitle.recorder.offline": "Sei offline. Controlla la connessione.",
  "subtitle.recorder.startRecord": "Clicca per iniziare a registrare.",
  "subtitle.recorder.recording": "Registrazione in corso...",
  "subtitle.recorder.uploadError": "Errore durante il caricamento del video.",
  "subtitle.recorder.tryAgain": "Controlla la connessione e riprova.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "Uso di fotocamera/microfono non consentito.",
  "subtitle.recorder.trySafariBrowser":
    "1. Usa il browser <code>SAFARI</code>.",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Clicca su <code>"aA"</code> nella barra dell’URL e poi su <code>"Impostazioni del sito"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Consenti l’uso</code> della fotocamera e del microfono",
  "subtitle.recorder.refreshPage": "4. Ricarica la pagina",
  "subtitle.recorder.tryChromeBrowser": "1. Usa il browser <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Vai su impostazioni del sito e clicca su <code>"Permessi"</code>',

  "message.recorder.almostDone": "Quasi finito! Solo qualche secondo in più.",
  "message.recorder.sendingMessage":
    "Stiamo inviando il tuo messaggio. Potrebbe volerci un po’ perché è pieno di cose belle.",

  "title.recorder.upload": "Caricamento",

  "subtitle.recorder.filesReadyToUpload": "File pronto per il caricamento:",

  "subtitle.recorder.fileWithError": "File che non verrà caricato:",

  "message.recorder.fileSizeError": "Il file supera la dimensione consentita",

  "button.recorder.send": "Invia",

  "message.recorder.uploading":
    "Per favore, non aggiornare o chiudere questa pagina.",

  "message.recorder.uploadError": "Errore durante il caricamento.",

  "title.recorder.uploadFailure": "Caricamento fallito",

  "title.recorder.completed": "Completato",

  "message.recorder.uploadComplete": "Caricamento completato",

  "message.recorder.fileUploaded": "File caricato con successo",

  "message.recorder.uploadFailed": "Errore nel caricamento del file",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Controlla la tua connessione e riprova",

  "button.recorder.ok": "OK!",

  "title.recorder.shareMoments": "Invia il tuo messaggio",

  "subtitle.recorder.forThe1YearAnniversary": "Per il 1º anniversario",

  "subtitle.recorder.now": "Per Adesso",

  "message.recorder.uploadMaxFilesLimit":
    "Carica <code>1 video</code> alla volta.",

  "message.recorder.uploadLimit": "Limite massimo:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> per video.",

  "button.recorder.send_video": "Invia video",

  "message.recorder.uploadTip":
    "Clicca sul pulsante qui sopra e seleziona il video appena registrato!",

  "title.recorder.guide.instructionsToRecord":
    "Istruzioni per la registrazione",

  "subtitle.recorder.guide.instructions":
    "Apri la <code>fotocamera</code> del tuo dispositivo in modalità selfie e registra il tuo messaggio fino a un massimo di <code>2 minuti</code>!",

  "subtitle.recorder.guide.moreInstructions":
    "Torna qui per inviare il tuo messaggio!",

  "message.recorder.instructions":
    "<code>Apri l'app fotocamera</code> del tuo dispositivo in modalità selfie e registra un messaggio di massimo <code>2 minuti</code>!",
  "button.recorder.sendVideo": "Invia video",
  "message.recorder.uploadTip.ios":
    "💡 Per una qualità migliore, seleziona un video dalla galleria",

  //uploader
  "button.uploader.send_photos": "Invia foto",
  "button.uploader.send_video": "Invia video",
  "button.uploader.close": "Chiudi",
  "button.uploader.share": "Condividi",
  "button.uploader.back": "Indietro",
  "button.uploader.send": "Invia",
  "button.uploader.continue": "Continua",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "Successo!",
  "title.uploader.uploading": "Caricamento in corso",
  "title.uploader.alert": "Attenzione!",
  "title.uploader.saving": "Salvataggio",
  "title.uploader.waiting": "Attendere",
  "title.uploader.share": "Condividi!",
  "title.uploader.error": "Errore!",
  "title.uploader.upload": "Upload",
  "title.uploader.shareMoments": "Condividi momenti",
  "title.uploader.uploadFailure": "Caricamento fallito",
  "title.uploader.completed": "Completato",
  "title.uploader.terms": "Termini di utilizzo",

  "subtitle.uploader.filesWithError":
    "File che <code>non verranno inviati</code>:",
  "subtitle.uploader.uploadHistory": "Invii completati",
  "subtitle.uploader.filesReadyToUpload": "File pronti per l'invio:",

  "message.uploader.uploadMaxFilesLimit":
    "Invia fino a <code>50 foto o 1 video</code> alla volta.",
  "message.uploader.uploadLimit": "Limite massimo:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> per foto",
  "message.uploader.videoSizeLimit": "<code>500MB</code> per video",
  "message.uploader.fileSizeError": "Il file supera la dimensione consentita.",
  "message.uploader.uploading":
    "Per favore, non aggiornare né chiudere questa pagina.",
  "message.uploader.uploadError": "Errore di caricamento.",
  "message.uploader.maxFilesLimitError":
    "Seleziona al <code>massimo 50 foto</code>.",
  "message.uploader.notFoundFilesToUpload":
    "<code>Nessun file disponibile per l’invio</code>.",
  "message.uploader.checkFileSizeAndTryAgain":
    "Controlla la <code>dimensione del file</code> e riprova.",
  "message.uploader.uploadComplete": "Caricamento completato",
  "message.uploader.allFilesUploaded": "Tutti i file sono stati inviati",
  "message.uploader.nFilesUploaded": "{n} file inviati",
  "message.uploader.nFilesNotUploaded": "{n} file non inviato/i",
  "message.uploader.noFilesUploaded": "Nessun file inviato",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Controlla la connessione e riprova.",
  "message.uploader.uploadVerySlow":
    "Se il caricamento è lento, seleziona meno foto alla volta",
  "message.uploader.uploadTip":
    "Per mantenere la qualità, carica i file direttamente dalla galleria del tuo dispositivo.",

  //guestForm
  "title.guestForm": "Il tuo profilo",
  "placeholder.guestForm.name": "Il tuo nome o soprannome",
  "message.guestForm.nameRequired": "Il nome è obbligatorio",
  "button.guestForm.takePhoto": "Scatta un selfie (opzionale)",
  "message.guestForm.dataInfo":
    "I dati forniti non sono obbligatori. Verranno mostrati solo come firma nelle foto e nei video che invii.",
  "button.guestForm.submit": "Salva",
  "button.guestForm.uploading": "Salvataggio in corso...",
  "button.guestForm.skip": "Continua in forma anonima",
  "message.cameraNotAvailable":
    "Impossibile accedere alla fotocamera. Assicurati di aver concesso i permessi alla fotocamera.",
  "title.guestForm.cropPhoto": "Ritaglia foto",
  "button.guestForm.selectPhoto": "Seleziona foto (opzionale)",

  //photoChallenge
  "title.photoChallenge": "Sfida fotografica",
  "subtitle.photoChallenge.tasks": "Obiettivi",
  "subtitle.photoChallenge.done": "Completati",
  "message.photoChallenge.intro":
    "L'obiettivo è scattare foto seguendo le indicazioni di ogni sfida.",
  "message.photoChallenge.todo": "Completa una sfida",
  "message.photoChallenge.done": "Sfide completate",
  "button.photoChallenge.start": "Inizia",

  //quiz
  "title.quiz": "Quiz",
  "subtitle.quiz.intro": "Accetti la sfida?",
  "subtitle.quiz.result": "Risultato",
  "message.quiz.intro":
    "Tra tutti gli invitati, dimostra di essere la persona che conosce meglio la coppia!",
  "button.quiz.start": "Inizia",
  "button.quiz.confirm": "Conferma",
  "message.quiz.result":
    "Hai risposto correttamente a {score} su {totalQuestions} domande in {time} secondi",
  "message.quiz.saving": "Salvataggio in corso...",
  "button.quiz.share": "Condividi risultato",
  "message.quiz.congrats": "🎉 Congratulazioni! 🎉",

  "message.bingo.intro":
    "Riesci a completare il bingo divertendoti con ogni sfida?",
  "button.bingo.start": "Inizia",
  "label.bingo.fullCard": "Cartella completa",
  "label.bingo.line": "Linea",
  "label.bingo.firstColumn": "1ª - Colonna",
  "label.bingo.firstRow": "1ª - Linea",
  "subtitle.bingo.results": "Risultati",
  "message.bingo.selectChallenge": "Clicca per vedere e completare la sfida",
  "button.bingo.removeChallenge": "Rimuovi sfida",
  "button.bingo.continue": "Continua",
  "message.bingo.progress": "Continua a completare le sfide del bingo!",
  "button.bingo.share": "Condividi",

  "message.photoChallenge.intro.new":
    "È facile: segui le istruzioni e divertiti a scattare foto!",
  "message.photoChallenge.inProgress.new":
    "Seleziona una sfida qui sotto e invia la tua foto.",
  "button.photoChallenge.share": "Condividi risultato",
  "message.photoChallenge.completed":
    "Hai completato tutte le {total} sfide fotografiche!",
  "message.photoChallenge.congrats": "🎉 Congratulazioni! 🎉",

  //teamMatch
  "title.teamMatch": "Team Match",
  "subtitle.teamMatch.intro": "Scopri la tua squadra",
  "subtitle.teamMatch.result": "Risultato",
  "message.teamMatch.intro":
    "Fai il test e scopri se fai parte della squadra {teamA} o della squadra {teamB}!",
  "button.teamMatch.start": "Inizia",
  "button.teamMatch.next": "Avanti",
  "message.teamMatch.result": "La tua squadra è <code>{team}</code>!",
  "message.teamMatch.saving": "Salvataggio in corso...",
  "button.teamMatch.share": "Condividi risultato",

  //feed
  "feed.loading": "Caricamento del feed...",
  "feed.empty": "Non ci sono ancora elementi nel feed.",
  "feed.imageAlt": "Immagine inviata",
  "feed.anonymousGuest": "Ospite anonimo",
  "feed.imageUploader.title": "Foto inviata",

  "feed.quiz.title": "Quiz",
  "feed.quiz.description":
    "{guestName} ha completato il quiz! Risultato: {score}/{total} in {time} secondi",
  "feed.photoChallenge.title": "Foto Sfida",
  "feed.photoChallenge.description":
    "{guestName} ha completato la sfida: {challenge}",
  "feed.teamMatch.title": "Team Match",
  "feed.teamMatch.description":
    "{guestName} ha partecipato al Team Match. Risultato: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Nuovo Ospite",
  "feed.newGuest.description": "{guestName} si è unito all’evento",
  "feed.videoRecorder.title": "Nuovo Messaggio",
  "feed.videoRecorder.description": "{guestName} ha inviato un nuovo messaggio",
  "feed.default.title": "Attività",
  "feed.default.description": "È avvenuta una nuova attività",

  "feed.ctaPost.ctaButton":
    "Ti stai divertendo all’evento? Pubblica anche tu una foto!",
  "feed.imageUploader.description":
    "{guestName} ha caricato dei file nella galleria della festa",
  "feed.cdt-imageUploader.title": "Nuovo messaggio",
  "feed.cdt-imageUploader.description":
    "{guestName} ha caricato dei file per il 1º anniversario!",
  "feed.quiz.ctaButton": "Metti alla prova le tue conoscenze",
  "feed.photoChallenge.ctaButton": "Partecipa anche tu a una sfida",
  "feed.teamMatch.ctaButton": "Partecipa al Team Match",
  "feed.videoRecorder.ctaButton": "Registra ora un messaggio",
  "feed.videoUploader.title": "Nuovo messaggio",
  "feed.videoUploader.description":
    "{guestName} ha caricato un video nella galleria della festa",
  "feed.cdt-videoUploader.title": "Nuovo messaggio",
  "feed.cdt-videoUploader.description":
    "{guestName} ha caricato un video per il 1º anniversario!",
  "feed.newPost.title": "Nuovo post",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> ha già lasciato un messaggio per il <code>1º anniversario!</code>",
  "feed.cdtVideoRecorder.ctaButton": "Fallo anche tu!",
  "feed.placeholder.newPost": "Crea post...",
  "feed.placeholder.newPostMessage": "Scrivi il tuo messaggio...",

  "feed.menu.title.interaction": "Invia file",
  "feed.menu.button.options.newPost": "Crea post",
  "feed.menu.message.options.newPost": "Crea subito un post!",
  "feed.menu.button.options.record": "Registra ora",
  "feed.menu.message.options.record": "Registra ora il tuo messaggio speciale!",
  "feed.menu.button.options.upload": "Scegli file",
  "feed.menu.message.options.upload":
    "Condividi le migliori foto e i video della festa!",
  "feed.menu.title.gallery": "Galleria della festa",
  "feed.menu.button.options.gallery": "Vedi album",
  "feed.menu.message.options.gallery": "Guarda le foto dell’evento!",
  "feed.menu.title.games": "Giochi",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Gioca al bingo della festa!",
  "feed.menu.button.options.photoChallengeGame": "Sfida fotografica",
  "feed.menu.message.options.photoChallengeGame":
    "Partecipa alla sfida fotografica!",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "Metti alla prova le tue conoscenze!",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame": "Di quale squadra fai parte?",
  "feed.menu.title.info": "Informazioni sull’evento",
  "feed.menu.button.options.foodMenu": "Menù",
  "feed.menu.message.options.foodMenu": "Guarda il menù della festa!",
  "feed.menu.button.options.schedule": "Programma",
  "feed.menu.message.options.schedule": "Consulta il programma della festa!",
  "feed.menu.title.guestInfo": "Le tue informazioni",
  "feed.menu.options.anonymousGuest": "Ospite anonimo",
  "feed.menu.options.guestEditInfo":
    "Clicca per modificare le tue informazioni!",
  "feed.menu.title.other": "Altro",
  "feed.menu.button.options.language": "Lingua",
  "feed.menu.message.options.languageInfo": "Clicca per cambiare la lingua!",
  "feed.button.options.cancel": "Annulla",
  "feed.button.options.confirm": "Conferma",
  "feed.menu.button.options.share": "Condividi",
  "feed.menu.message.options.shareInfo": "Condividi il link dell’evento!",
  "feed.menu.button.options.about": "Informazioni sulla Capsula del Tempo",
  "feed.menu.message.options.about": "Scopri la Capsula del Tempo!",
  "feed.createPost.title": "Nuovo post",
  "feed.button.creatingPost": "Pubblicazione...",
  "feed.button.createPost": "Pubblica",
  "feed.editImage.title": "Modifica immagine",
  "feed.newPost.selectImage": "Seleziona immagine",
  "feed.createPost.info.sendingPostImage": "Invio immagine...",
  "feed.createPost.info.creatingPost": "Creazione post...",
  "feed.createPost.info.finalizingPost": "Finalizzazione...",
  "feed.menu.button.options.games": "Giochi",
  "feed.modalGames.title": "Giochi della festa",
  "feed.bingo.result.line": "Linea",
  "feed.bingo.result.column": "Colonna",
  "feed.bingo.result.fullCard": "Cartella completa",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description":
    "{guestName} ha completato una {challenge} del bingo",
  "feed.bingo.ctaButton": "Gioca anche tu al bingo",
  "feed.deletePost.title": "Elimina post",
  "feed.deletePost.message":
    "Sei sicuro di voler eliminare questo post? Questa azione non può essere annullata.",

  "title.uploader.modalMixedEventTitle":
    "QUANDO vuoi che gli sposi ricevano la tua foto o video?",
  "button.options.sendNow": "Invia subito",
  "message.options.sendNow":
    "Gli sposi avranno accesso ai file immediatamente!",
  "button.options.sendLater": "Per il primo anniversario di matrimonio",
  "message.options.sendLater": "Invia per la Capsula del Tempo dell'evento!",

  "button.cancel": "Annulla",
  "button.delete": "Elimina",
  "button.quiz.continue": "Continua",
  "button.recorder.recorder.back": "Indietro",
  "button.teamMatch.continue": "Continua",
  "cropper.remove.frame": "Rimuovi cornice",
  "cropper.use.frame": "Usa cornice",
  "error.guestForm.fileTooLarge": "Il file deve essere al massimo 10MB",
  "error.guestForm.invalidFileType": "Seleziona un file immagine valido",
  "error.guestForm.removePhotoFailed": "Rimozione foto fallita. Riprova.",
  "error.guestForm.saveFailed": "Salvataggio fallito. Riprova.",
  "error.guestForm.updateFailed": "Salvataggio fallito. Riprova.",
  "error.guestForm.uploadFailed": "Caricamento foto fallito. Riprova.",
  "title.guestForm.unsavedChanges": "Modifiche non salvate",
  "message.guestForm.unsavedChanges":
    "Hai modifiche non salvate. Vuoi uscire senza salvare?",
  "button.guestForm.cancel": "Annulla",
  "button.guestForm.exitWithoutSaving": "Esci senza salvare",
  "message.bingo.remove.warning":
    "Eliminando questa sfida, i tuoi risultati saranno ricalcolati.",
  "message.bingo.remove.warning.detail1":
    "Le righe e le colonne interessate dall'eliminazione saranno riviste.",
  "message.bingo.remove.warning.detail2":
    "Se ci sono altri traguardi completati, l'ora sarà aggiornata al momento attuale.",
  "message.guest.nameRequired": "Il nome è obbligatorio",
  "message.quiz.progress":
    "Il quiz è ancora in corso! Continua e mostra di cosa sei capace!",
  "message.teamMatch.progress":
    "Il gioco è ancora in corso! Continua e scopri la tua squadra!",
  "title.feed": "Feed della festa",
};

export default message;
